/**
 * Firestore auto-generated document ids are exactly 20 base62 characters. A
 * `name` field matching this shape is almost certainly a leaked id (e.g. a
 * coach-proposed session written with the wrong field) rather than a real
 * user-entered title — no legitimate title is a bare 20-char id string.
 */
const GENERATED_ID_PATTERN = /^[A-Za-z0-9]{20}$/;

/**
 * Trims `name` and returns it, or null when unset/blank/corrupted (looks
 * like a raw document id). Use in place of `name?.trim() || fallback` for
 * any user-facing name field so a leaked id can never render as a title.
 */
export function asDisplayNameOrNull(
  name: string | null | undefined,
): string | null {
  const trimmed = name?.trim();
  if (!trimmed) return null;
  return GENERATED_ID_PATTERN.test(trimmed) ? null : trimmed;
}
